import React from 'react';
import './Header.css';
import { Link } from 'react-router-dom';

function Header({ onMenuClick }) {
  return (
    <header className="header">
      <div className="header-container">
        <button className="menu-button" onClick={onMenuClick}>
          <span className="menu-icon">☰</span>
        </button>
        <Link to="/" className="logo">
          <h1>NyotaFund</h1>
        </Link>
        <div className="header-spacer"></div>
      </div>
    </header>
  );
}

export default Header;